module.exports = __webpack_public_path__ + "static/img/pyramids.b01cee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/pyramids.jpg
// module id = 7+rr
// module chunks = 1